import React from 'react'

const AnunciantesRoutes = [
    {
        path: '/anunciantes/usuarios',
        exact: true,
        component: React.lazy(() => import('./usuarios/lista/Table')),
    },
    {
        path: '/anunciantes/usuarios/novo',
        exact: true,
        component: React.lazy(() => import('./usuarios/form/Form')),
    },
    {
        path: '/anunciantes/financeiro/visualizacoes',
        exact: true,
        component: React.lazy(() => import('./Financeiro/visualizacoes/Form')),
    },
    {
        path: '/anunciantes/financeiro',
        exact: true,
        component: React.lazy(() => import('./Financeiro/Registros_Financeiros/lista/TableRegistrosFinanceiros')),
    },
    {
        path: '/anunciantes/financeiro/visualizar',
        exact: true,
        component: React.lazy(() => import('./Financeiro/visualizar/Form')),
    },

    // 🔹 Nova rota pública de validação de resgate
    {
    path: '/anunciantes/resgatar/:rc',
    exact: true,
    component: React.lazy(() =>
      import('../../../pages/Anunciantes/ResgateCupomPage') // << caminho corrigido
    ),
  },
]

export default AnunciantesRoutes
